"use client";

import { HIDE_SCROLLBAR_STYLE } from "@/app/layout/LayoutConstants";
import AdDetailModel from "@/models/AdDetailModel";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "next/link";

export default function AdBreadcrumbs({ ad }: { ad: AdDetailModel }) {
  return (
    <Breadcrumbs
      sx={(theme) => ({
        ...theme.typography.caption,
        minWidth: 0,
        ol: {
          flexWrap: "nowrap",
          overflowX: "auto",
          ...HIDE_SCROLLBAR_STYLE,
          li: {
            flexShrink: 0,
          },
        },
      })}
    >
      <Link href="/for-sale/everything-equine">Everything Equine</Link>
      {ad.breadcrumbs.map((breadcrumb) => (
        <Link key={breadcrumb.url} href={breadcrumb.url}>
          {breadcrumb.label}
        </Link>
      ))}
      <Typography sx={{ fontSize: "inherit" }}>#{ad.id}</Typography>
    </Breadcrumbs>
  );
}
